import React, { useState } from "react";

import './FilterButton.scss'
import { Radio } from "antd";
import { FILTER_ACTIONS } from "../../shared/const/consts";



const FilterButton = (props) => {

    const [filterClicked, setFilterClicked] = useState(FILTER_ACTIONS.NO_FILTER);
    const {isThreeState, value, filterIndex, onInclude, onExclude, onNoFilter} = props;

    const handleFilterChange = (e) => {
        setFilterClicked(e.target.value);
    };

    return (
        <div className="filter-button-wrapper">
            <label className="filter-button-text">
                {value}
            </label>
            <Radio.Group 
                value={filterClicked} 
                className="filter-button-radiogroup" 
                style={{'flex-direction': 'row'}}
                onChange={handleFilterChange}
            >
                <Radio.Button 
                    onClick={() => {onInclude(value,filterIndex)}}
                    value={FILTER_ACTIONS.INCLUDE}
                >
                    Include
                </Radio.Button>
                {isThreeState ? 
                    <Radio.Button 
                        onClick={() => {onExclude(value,filterIndex)}}
                        value={FILTER_ACTIONS.EXCLUDE}
                    >
                        Exclude
                    </Radio.Button> 
                : null}
                <Radio.Button 
                    onClick={() => {onNoFilter(value,filterIndex)}}
                    value={FILTER_ACTIONS.NO_FILTER}
                >
                    Optional
                </Radio.Button>
            </Radio.Group>
        </div>
    );
};

export default FilterButton;